import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 82 50">
                  <path fill="#ffffff"
                    d="M7.8,4.6C7.8,6.4,6.2,8,4.4,8C2.5,8,1,6.4,1,4.6c0-1.9,1.5-3.4,3.4-3.4C6.2,1.2,7.8,2.7,7.8,4.6z M1.6,42.7h5.6V10.7H1.6
V42.7z M29.3,13c2,1.8,2.9,4.1,2.9,7.2v13.4c0,3.1-1,5.5-2.9,7.2c-2,1.8-4,2.7-6.3,2.7c-2,0-3.7-0.5-5-1.5v6.8h-5.6V20.2
c0-3.1,1-5.5,2.9-7.2c2-1.8,4.3-2.7,7-2.7C25,10.2,27.4,11.1,29.3,13z M26.7,20.2c0-3.7-1.9-5.3-4.3-5.3c-2.4,0-4.3,1.6-4.3,5.3
v13.4c0,3.7,1.9,5.2,4.3,5.2c2.4,0,4.3-1.7,4.3-5.3V20.2z M46.8,10.2c-2.7,0-5,0.9-7,2.7c-2,1.8-2.9,4.1-2.9,7.2v13.4
c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2c0,3.6-1.9,5.3-4.3,5.3
c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6h5.6v-0.6c0-3.1-1-5.5-2.9-7.2
C51.8,11.1,49.5,10.2,46.8,10.2z M81,20.8v-0.6c0-3.1-1-5.5-2.9-7.2c-2-1.8-4.3-2.7-7-2.7c-2.7,0-5,0.9-7,2.7
c-2,1.8-2.9,4.1-2.9,7.2v13.4c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2
c0,3.6-1.9,5.3-4.3,5.3c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6H81z"
                  ></path>
                </svg>
        <p>© Intergovernmental Panel on Climate Change, 2023</p>
      </div>
      <div className="footer-bottom">
      <div className="footer-logo">
        <a href="https://ipcc.ch/" target="_blank" rel="noreferrer">
          <StaticImage
            src="../img/footer/footer-left.png"
            alt=""
            className="w-100 h-100 img-fluid footer-img"
          />
        </a>
      </div>
      <div className="footer-links">
        <a href="https://www.ipcc.ch/about/" target="_blank" rel="noreferrer">About</a>
        <a href="https://www.ipcc.ch/copyright/" target="_blank" rel="noreferrer">Copyright</a>
        <a href="https://www.ipcc.ch/disclaimer/" target="_blank" rel="noreferrer">Disclaimer</a>
        <a href="https://www.ipcc.ch/privacy-policy-2/" target="_blank" rel="noreferrer">Privacy Policy</a>
      </div>
      <div className="footer-social">
        <a
          href="https://twitter.com/IPCC_CH"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-twitter"></i>
        </a>
        <a
          href="https://www.facebook.com/IPCC/"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-facebook-square"></i>
        </a>
        <a
          href="https://www.instagram.com/ipcc/?hl=en"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-instagram"></i>
        </a>
        <a
          href="https://vimeo.com/ipcc"
          target="_blank"
          className="link text-white"
          rel="noreferrer"
        >
          <i className="bx bxl-vimeo"></i>
        </a>
      </div>
      </div>
    </footer>
  )
}
export default Footer
